module.exports = __webpack_public_path__ + "static/media/03n.4b0ff495.svg";